module.exports = __webpack_public_path__ + "img/back.9306400a.svg";